import { type ChangeEvent, useState } from "react";

export interface UseInputReturn<T = string> {
  value: T;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  initValue: (value: T) => void;
  clearValue: () => void;
}

export const useInput = <T = string>(
  inputValue: T = "" as T
): UseInputReturn<T> => {
  const [value, setValue] = useState<T>(inputValue);
  const onChange = (event: ChangeEvent<HTMLInputElement>) =>
    setValue(event.target.value as T);
  const initValue = (newValue: T) => setValue(newValue);
  const clearValue = () => setValue("" as T);
  return { value, onChange, initValue, clearValue };
};
